import type {
  UpdateTeamMemberMutation,
  UpdateTeamMemberMutationVariables
} from './__generated__/UpdateTeamMemberMutation'
import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'

const mutation: TypedDocumentNode<
  UpdateTeamMemberMutation,
  UpdateTeamMemberMutationVariables
> = gql`
  mutation UpdateTeamMemberMutation($input: UpdateTeamMemberInput!) {
    updateTeamMember(input: $input) {
      status
    }
  }
`

export function updateTeamMemberMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      UpdateTeamMemberMutation,
      UpdateTeamMemberMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
